/**
 * LA PAGINA
 * =============================================================================
 * Arma las secciones en el orden de tus referencias:
 *
 *   1 · Portada ........... «MAS QUE FUTBOL» con la franja de cinco pilares
 *   2 · Academia .......... formacion integral, mision y vision
 *   3 · Metodologia ....... los cuatro pilares y el sistema hibrido
 *   4 · Programas ......... los cinco programas y lo que todos incluyen
 *   5 · Competencias ...... ligas, torneos y el cierre en cursiva
 *   6 · Informacion ....... escribirnos, correo, ubicacion y horarios
 *   7 · Contacto .......... inscripciones, proceso, mapa, redes y formulario
 *
 * -----------------------------------------------------------------------------
 * TODO ES HTML DE VERDAD
 * -----------------------------------------------------------------------------
 * Las imagenes de referencia se usaron como guia visual, no como contenido. Cada
 * titulo es un `h2`, cada parrafo un `p`, cada boton un `button`, y cada fotografia
 * un archivo independiente con su propia proporcion.
 *
 * No hay ni una captura de pantalla colocada como seccion.
 */

import { Cabecera, Pie } from './componentes/Cabecera';
import { Instalar } from './componentes/Instalar';
import { useIdioma } from './i18n/useIdioma';
import { Portada } from './secciones/Portada';
import { Academia } from './secciones/Academia';
import { Metodologia } from './secciones/Metodologia';
import { Programas } from './secciones/Programas';
import { Competencias } from './secciones/Competencias';
import { Informacion } from './secciones/Informacion';
import { Galeria } from './secciones/Galeria';
import { Notificaciones } from './componentes/Notificaciones';
import { Contacto } from './secciones/Contacto';

export function Pagina() {
  const { textos } = useIdioma();

  return (
    <>
      {/* Para quien navega con el teclado: el primer Tab lleva directo al
          contenido, sin pasar por todo el menu. */}
      <a className="saltar" href="#inicio">
        {textos.a11y.irAlContenido}
      </a>

      <Cabecera />

      {/* La ventana para instalar la pagina en el telefono. Se ofrece sola la
          primera vez y luego queda en una pastilla. */}
      <Instalar />

      <main>
        <Portada />
        <Academia />
        <Metodologia />
        <Programas />
        <Competencias />
        <Informacion />

        {/* Las fotos que el administrador pone desde el panel. Si no hay
            ninguna, la sección no se muestra. */}
        <Galeria />

        {/* El boton para recibir los avisos. Si estan apagados desde el panel,
            no se muestra. */}
        <Notificaciones />

        <Contacto />
      </main>

      <Pie />
    </>
  );
}
